const t = {
  name: "Folder",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 6C1 4.34315 2.34315 3 4 3H10.1716C10.9672 3 11.7303 3.31607 12.2929 3.87868L14.4142 6H20C21.6569 6 23 7.34315 23 9V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V6ZM4 5C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V9C21 8.44772 20.5523 8 20 8H13.5858L10.8787 5.29289C10.6911 5.10536 10.4368 5 10.1716 5H4Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Folder
};
